export var ExplorePageSubjects;
(function (ExplorePageSubjects) {
    ExplorePageSubjects["Page"] = "explore-page";
    ExplorePageSubjects["OpenFilterPanelButton"] = "explore-open-filter-panel-button";
    ExplorePageSubjects["FilterPanel"] = "explore-filters-panel";
    ExplorePageSubjects["FilterPanelSkeleton"] = "explore-filter-panel-skeleton";
    ExplorePageSubjects["FilterPanelField"] = "explore-filter-panel-field";
    ExplorePageSubjects["FilterPanelCloseButton"] = "explore-filter-panel-close-button";
    ExplorePageSubjects["FilterPanelSection"] = "explore-filter-panel-section";
    ExplorePageSubjects["FilterPanelSectionCount"] = "explore-filter-panel-section-count";
    ExplorePageSubjects["FilterPanelSectionLoading"] = "explore-filter-panel-section-loading";
    ExplorePageSubjects["FilterGraph"] = "explore-filter-graph";
    ExplorePageSubjects["Graph"] = "explore-graph";
    ExplorePageSubjects["SearchResultsTable"] = "search-results-data-table";
    ExplorePageSubjects["QuickView"] = "quick-view";
    ExplorePageSubjects["QuickViewJson"] = "quick-view-json";
    ExplorePageSubjects["ExpandedLogJson"] = "expanded-log-json";
    ExplorePageSubjects["ExpandedLogTable"] = "expanded-log-table";
    ExplorePageSubjects["ExpandedSingleLogButton"] = "expanded-single-log-button";
    ExplorePageSubjects["ExpandedCopyButton"] = "expanded-copy-button";
    ExplorePageSubjects["ExpandedSurroundingLogsButton"] = "expanded-surrounding-logs-button";
    ExplorePageSubjects["QuickViewModeButton"] = "quick-view-mode-select-button";
    ExplorePageSubjects["QuickViewCloseButton"] = "quick-view-close-button";
    ExplorePageSubjects["QuickViewCopyButton"] = "quick-view-copy-button";
    ExplorePageSubjects["QuickViewCopyNotification"] = "quick-view-copy-notification";
    ExplorePageSubjects["ExploreAsDefaultSuccessNotification"] = "explore-as-default-success-notification";
    ExplorePageSubjects["ExploreAsDefaultFailureNotification"] = "explore-as-default-failure-notification";
    ExplorePageSubjects["QuickViewNotFoundNotification"] = "quick-view-not-found-notification";
    ExplorePageSubjects["QuickViewSurroundingLogsButton"] = "quick-view-surrounding-logs-button";
    ExplorePageSubjects["AccountSelector"] = "filter-panel-account-selector";
    ExplorePageSubjects["FiltersSearchBar"] = "filters-search-bar";
    ExplorePageSubjects["FiltersContainer"] = "filters-container";
    ExplorePageSubjects["ToggleModeButton"] = "smart-search-mode-toggle";
    ExplorePageSubjects["ToggleModePopover"] = "smart-search-mode-popover";
    ExplorePageSubjects["AIButton"] = "explore-page-ai-button";
    ExplorePageSubjects["GraphGroupBy"] = "graph-group-by";
    ExplorePageSubjects["GraphScaleTypeSelectButton"] = "graph-scale-type-select-button";
    ExplorePageSubjects["Totals"] = "total-logs";
    ExplorePageSubjects["SmartSearch"] = "smart-search-component";
    ExplorePageSubjects["SmartSelect"] = "smart-select";
    ExplorePageSubjects["PreviewInExplore"] = "preview-in-explore";
    ExplorePageSubjects["VirtualizedFilterFieldsList"] = "explore-filter-panel-virtualized-filter-fields-list";
    ExplorePageSubjects["SearchButton"] = "explore-search-button";
    ExplorePageSubjects["DensityModeSelectButton"] = "density-mode-select-button";
    ExplorePageSubjects["DensityModeSelectMenu"] = "density-mode-select-menu";
    ExplorePageSubjects["AutoRefreshSelectButton"] = "auto-refresh-select-button";
    ExplorePageSubjects["AutoRefreshSelectMenu"] = "auto-refresh-select-menu";
    ExplorePageSubjects["AutoRefreshOption"] = "auto-refresh-option";
    ExplorePageSubjects["QuickViewLogTable"] = "quick-view-log-table";
    ExplorePageSubjects["AlertsInExploreToggle"] = "alerts-in-explore-toggle";
    ExplorePageSubjects["CreateAlert"] = "create-alert";
    ExplorePageSubjects["CreateOptimizer"] = "create-optimizer";
    ExplorePageSubjects["CopyUrl"] = "copy-url";
    ExplorePageSubjects["CloseQuickview"] = "close-quickview";
    ExplorePageSubjects["TableJsonFormatter"] = "explore-table-json-formatter";
    ExplorePageSubjects["MultiTag"] = "explore-multi-tag";
    ExplorePageSubjects["ActionsMenu"] = "explore-actions-menu";
    ExplorePageSubjects["OpenPreferencesButton"] = "open-preferences-button";
    ExplorePageSubjects["ExportAllButton"] = "export-all";
    ExplorePageSubjects["SmartSelectActions"] = "explore-smart-select-actions";
    ExplorePageSubjects["SmartSelectPopover"] = "explore-smart-select-popover";
    ExplorePageSubjects["SmartSelectPopoverOption"] = "explore-smart-select-popover-option";
    ExplorePageSubjects["ViewExceptions"] = "explore-view-exceptions";
    ExplorePageSubjects["ExceptionsQuickViewTable"] = "explore-exceptions-quick-view-table";
    ExplorePageSubjects["RcaExceptionButton"] = "explore-rca-exception-button";
    ExplorePageSubjects["OpenSavedSearchButton"] = "open-saved-search-button";
    ExplorePageSubjects["SaveSavedSearchButton"] = "save-saved-search-button";
    ExplorePageSubjects["CancelSavedSearchButton"] = "cancel-saved-search-button";
    ExplorePageSubjects["FindSavedSearchInput"] = "find-saved-search-input";
    ExplorePageSubjects["SortSavedSearchButton"] = "sort-saved-search-button";
    ExplorePageSubjects["SavedSearchListItem"] = "saved-search-list-item";
    ExplorePageSubjects["SavedSearchTitleWithTotalValues"] = "saved-search-title-with-total-values";
    ExplorePageSubjects["SavedSearchEmptyStateImportButton"] = "saved-search-empty-state-import-button";
    ExplorePageSubjects["SavedSearchEmptySearchImportButton"] = "saved-search-empty-search-import-button";
    ExplorePageSubjects["SavedSearchItemName"] = "saved-search-item-name";
    ExplorePageSubjects["SavedSearchEditItemNameInput"] = "saved-search-edit-item-name-input";
    ExplorePageSubjects["SavedSearchDeleteItemButton"] = "saved-search-delete-item-button";
    ExplorePageSubjects["SavedSearchEditItemButton"] = "saved-search-edit-item-button";
    ExplorePageSubjects["SavedSearchConfirmItemButton"] = "saved-search-confirm-item-button";
    ExplorePageSubjects["SavedSearchIsFavoriteInputButton"] = "saved-search-isFavorite-item-button";
    ExplorePageSubjects["SavedSearchCreateInput"] = "saved-search-create-input";
    ExplorePageSubjects["SavedSearchCreateNotification"] = "saved-search-create-notification";
    ExplorePageSubjects["SavedSearchDeleteNotification"] = "saved-search-delete-notification";
    ExplorePageSubjects["SavedSearchUpdateNotification"] = "saved-search-update-notification";
    ExplorePageSubjects["SavedSearchItemActions"] = "saved-search-item-actions";
    ExplorePageSubjects["SavedSearchPopover"] = "saved-search-popover";
    ExplorePageSubjects["SinglLogAiInvestigateButton"] = "investigate-this-log";
    ExplorePageSubjects["SmartSelectValues"] = "smart-select-values";
    ExplorePageSubjects["OpenSingleLogButton"] = "open-single-log-button";
    ExplorePageSubjects["ToggleUtc"] = "explore-toggle-utc";
    ExplorePageSubjects["VisualizationMenu"] = "explore-visualization-menu";
    ExplorePageSubjects["VisualizationMenuButton"] = "explore-visualization-menu-button";
    ExplorePageSubjects["VisualizationMenuPopover"] = "explore-visualization-menu-popover";
    ExplorePageSubjects["SpansGraphMetricSelect"] = "spans-graph-metric-select";
    ExplorePageSubjects["SpansGraphLatencyPercentileToggle"] = "spans-graph-latency-percentile";
    ExplorePageSubjects["AIObservabilityGraphMetricSelect"] = "ai-observability-graph-metric-select";
    ExplorePageSubjects["AIObservabilityGraphLatencyPercentileToggle"] = "ai-observability-graph-latency-percentile";
    ExplorePageSubjects["ExpandedRowTabs"] = "explore-expanded-row-tabs";
    ExplorePageSubjects["ExpandedRowK8sStrip"] = "explore-expanded-row-k8s-strip";
    ExplorePageSubjects["ExpandedRowK8sTab"] = "explore-expanded-row-k8s-tab";
    ExplorePageSubjects["ExpandedRowK8sActionsMenu"] = "explore-expanded-row-k8s-actions-menu";
    ExplorePageSubjects["LuceneEditor"] = "explore-lucene-editor";
    ExplorePageSubjects["ExploreDeploymentsSettingSelected"] = "explore-deployments-setting-selected";
    ExplorePageSubjects["ExploreDeploymentsSettingAll"] = "explore-deployments-setting-all";
    ExplorePageSubjects["ExploreDeploymentsSetting"] = "explore-deployments-setting";
    ExplorePageSubjects["OpenUnifiedDashboardModal"] = "explore-open-unified-dashboard-modal";
    ExplorePageSubjects["UnifiedDashboardModalPreviewButton"] = "explore-unified-dashboard-modal-preview-button";
    ExplorePageSubjects["FilterTag"] = "explore-filter-tag";
    ExplorePageSubjects["FilterTagEditPopover"] = "explore-filter-tag-edit-popover";
    ExplorePageSubjects["ColdTier"] = "explore-cold-tier";
})(ExplorePageSubjects || (ExplorePageSubjects = {}));
export var ExplorePageGraphYAxisScaleTypes;
(function (ExplorePageGraphYAxisScaleTypes) {
    ExplorePageGraphYAxisScaleTypes["Linear"] = "linear";
    ExplorePageGraphYAxisScaleTypes["Logarithmic"] = "logarithmic";
    ExplorePageGraphYAxisScaleTypes["SquareRoot"] = "squareRoot";
})(ExplorePageGraphYAxisScaleTypes || (ExplorePageGraphYAxisScaleTypes = {}));
export var ExplorePageDensityModes;
(function (ExplorePageDensityModes) {
    ExplorePageDensityModes["OneLine"] = "OneLine";
    ExplorePageDensityModes["TwoLines"] = "TwoLines";
    ExplorePageDensityModes["Expanded"] = "Expanded";
})(ExplorePageDensityModes || (ExplorePageDensityModes = {}));
export var ExplorePreferencesSubjects;
(function (ExplorePreferencesSubjects) {
    ExplorePreferencesSubjects["Page"] = "explore-preferences";
    ExplorePreferencesSubjects["DensityTitle"] = "preferences-keybindings-section-title";
    ExplorePreferencesSubjects["Density"] = "preferences-keybindings-section-subtitle";
})(ExplorePreferencesSubjects || (ExplorePreferencesSubjects = {}));
export var FilterFieldSettingsIds;
(function (FilterFieldSettingsIds) {
    FilterFieldSettingsIds["EXISTS"] = "exists";
    FilterFieldSettingsIds["NOT_EXISTS"] = "not-exists";
    FilterFieldSettingsIds["REMOVE_EXISTS"] = "remove-exists";
    FilterFieldSettingsIds["TABLE"] = "table";
    FilterFieldSettingsIds["BOOKMARK"] = "bookmark";
    FilterFieldSettingsIds["CLEAR"] = "clear";
    FilterFieldSettingsIds["GRAPH"] = "graph";
})(FilterFieldSettingsIds || (FilterFieldSettingsIds = {}));
export var ExploreSurroundingPage;
(function (ExploreSurroundingPage) {
    ExploreSurroundingPage["LoadLogsBar"] = "load-surrounding-logs-bar";
    ExploreSurroundingPage["LoadLogsBarInput"] = "load-surrounding-logs-bar-input";
})(ExploreSurroundingPage || (ExploreSurroundingPage = {}));
export var ExploreSingleLogPage;
(function (ExploreSingleLogPage) {
    ExploreSingleLogPage["Page"] = "single-log-view-page";
    ExploreSingleLogPage["SingleLogViewTable"] = "single-log-view-table";
    ExploreSingleLogPage["SingleLogViewJson"] = "single-log-view-json";
    ExploreSingleLogPage["SingleLogViewCopyButton"] = "single-log-view-copy-button";
    ExploreSingleLogPage["SingleLogViewSurroundingLogsButton"] = "single-log-view-surrounding-logs-button";
})(ExploreSingleLogPage || (ExploreSingleLogPage = {}));
export var ExpandedDocumentTabNames;
(function (ExpandedDocumentTabNames) {
    ExpandedDocumentTabNames["LOG"] = "Log";
    ExpandedDocumentTabNames["TRACE"] = "Trace";
    ExpandedDocumentTabNames["KUBERNETES"] = "Kubernetes";
})(ExpandedDocumentTabNames || (ExpandedDocumentTabNames = {}));
export var ExploreTimeInterval;
(function (ExploreTimeInterval) {
    ExploreTimeInterval["Auto"] = "auto";
    ExploreTimeInterval["Millisecond"] = "ms";
    ExploreTimeInterval["Second"] = "s";
    ExploreTimeInterval["Minute"] = "m";
    ExploreTimeInterval["Hour"] = "h";
    ExploreTimeInterval["Day"] = "d";
    ExploreTimeInterval["Week"] = "w";
    ExploreTimeInterval["Month"] = "M";
    ExploreTimeInterval["Year"] = "y";
})(ExploreTimeInterval || (ExploreTimeInterval = {}));
export var ExploreWarmTier;
(function (ExploreWarmTier) {
    ExploreWarmTier["WarmDataSlowerResponseTimesWarning"] = "warm-data-slower-response-times-warning";
    ExploreWarmTier["WarmDataSuccessfullyRetrieveNotification"] = "warm-data-successfully-retrieve-notification";
})(ExploreWarmTier || (ExploreWarmTier = {}));
export var UnifiedDashboardModalFieldNames;
(function (UnifiedDashboardModalFieldNames) {
    UnifiedDashboardModalFieldNames["DASHBOARD"] = "dashboard";
    UnifiedDashboardModalFieldNames["PANEL_GROUP"] = "panelGroup";
    UnifiedDashboardModalFieldNames["PANEL_NAME"] = "panelName";
})(UnifiedDashboardModalFieldNames || (UnifiedDashboardModalFieldNames = {}));
//# sourceMappingURL=explore.enum.js.map